import ApiService from '@/common/api.service'
export default {
  searchKnowHow () {
    return new Promise((resolve, reject) => {
      ApiService.query('/know-how/list').then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  referKnowHow (id) {
    return new Promise((resolve, reject) => {
      ApiService.query('/know-how/refer/' + id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
